import apiWorker from '../apiWorker'

export default {

    update           : (_id, data)            => apiWorker('patch', `/api/v1/core/appointments/update/${_id}`, data),
    findNotification : (_id, hideError)       => apiWorker('get', `/api/v1/core/appointments/find_notification/${_id}`, null, hideError),

}
